/**
 * AnimationPlayer R3F component registration.
 */
import { nodeComponentRegistry } from '../../../r3f/NodeComponentRegistry';
import { AnimationPlayer } from './Component';
nodeComponentRegistry.register({
    typeName: 'AnimationPlayer',
    Component: AnimationPlayer,
    container: true,
    renderIntent: 'transform-only',
});
//# sourceMappingURL=index.r3f.js.map